<template>
  <v-container fiuld fill-height>
    <v-row>
      <v-col cols="12">
        <div class="forecast text-center" v-if="forecastArray !== undefined">
          <div class="forecast-day mb-5" v-for="day in forecastArray" :key="day.forecastDate">
            <div class="forecast-day-tile primary white--text d-flex flex-column justify-center align-center elevation-3 rounded mx-auto mb-2">
              <div class="text-h4">
                {{ dateFormatter(day.forecastDate)[3] }}
              </div>
              <div class="text-caption">
                {{ day.week }}
              </div>

            </div>

            <div class="forecast-day-icon text-center">
              <img :src="require(`@/assets/weather-icons/icon-${day.ForecastIcon}.png`)" alt="Forecast Icon">
            </div>

            <div class="forecast-day-number mb-4">
              <div class="forecast-day-number__temp d-flex align-center justify-center mb-2">
                  <v-icon>
                    mdi-arrow-down-thick
                  </v-icon>
                  {{ day.forecastMintemp.value }}°C
                  <v-icon class="ml-3">
                    mdi-arrow-up-thick
                  </v-icon>
                  {{ day.forecastMaxtemp.value }}°C
              </div>
              <div class="forecast-day-number__humidity">
                <span>
                  {{ day.forecastMinrh.value }} ~ {{ day.forecastMaxrh.value }}%
                </span>
              </div>
            </div>

            <div class="forecast-day-text">
              <p class="text-body-2">
                {{ day.forecastWeather }}
              </p>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12">
        <div class="d-flex align-center" v-if="lastUpdate !== ''">
          <v-spacer></v-spacer>
          <v-icon class="mr-3" v-show="isLoading">
            mdi-loading mdi-spin
          </v-icon>
          <span class="text-caption">
            最後更新時間：{{ dateTrimmer(lastUpdate) }} {{ timeTrimmer(lastUpdate) }}
          </span>
          <v-icon class="ml-3" @click="fetchWeatherForecast">
            mdi-refresh
          </v-icon>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: ()=>({

  }),
  computed: {
    forecastArray(){
      return this.$store.state.weatherForecast.forecastArray;
    },
    lastUpdate(){
      return this.$store.state.weatherForecast.lastUpdate;
    },
    isLoading(){
      return this.$store.state.weatherForecast.isLoading;
    }
  },
  methods: {
    fetchWeatherForecast(){
      this.$store.dispatch('fetchWeatherForecast');
    }
  },
  created(){
    this.fetchWeatherForecast();
  }
}
</script>

<style lang="scss">
.forecast {
  display: grid;
  grid-template-columns: repeat(9, 1fr);
  grid-template-rows: auto;

  @media only screen and (max-width: 576px){
    grid-template-columns: 1fr;
    grid-template-rows: repeat(9, auto);
  }

  &-day {

    &-tile {
      width: 75px;
      height: 75px;
    }
  }
}
</style>
